import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

export const getBrokers = () => api.get('/brokers');
export const getBroker = (slug) => api.get(`/brokers/${slug}`);
export const createBroker = (data) => api.post('/brokers', data);
export const updateBroker = (slug, data) => api.put(`/brokers/${slug}`, data);
export const deleteBroker = (slug) => api.delete(`/brokers/${slug}`);

export const getArticles = () => api.get('/articles');
export const getArticle = (slug) => api.get(`/articles/${slug}`);
export const createArticle = (data) => api.post('/articles', data);
export const updateArticle = (slug, data) => api.put(`/articles/${slug}`, data);
export const deleteArticle = (slug) => api.delete(`/articles/${slug}`);

export const getLegalPages = () => api.get('/legal-pages');
export const getLegalPage = (slug) => api.get(`/legal-pages/${slug}`);
export const createLegalPage = (data) => api.post('/legal-pages', data);

export const searchContent = (query, type = 'all') => api.get(`/search?q=${encodeURIComponent(query)}&type=${type}`);

export default api;
